<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/G7SOUv/tc-custom/9781504040853.jpg?1734183156781" alt="This image is the cover for the book Hard Money"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hard Money
      </h1>
      <p class="bookDescription body article font2">
        <b>An early master of the western spins a dramatic yarn about a ruthless mine baron and the unlikely duo who risk their lives to stop his dastardly plans.</b><br/><br/> Charles Bonal is a self-made man who believes in getting the job done whatever the obstacle. But his newest project to drive a tunnel through the mountains is hitting more than immovable earth. A vicious mining magnate, Chris Feldhake, doesn’t want Bonal interfering with his own plans to expand his power and empire—and he’ll kill to stop him.<br/>  <br/> Phil Seay will do anything to make his way in the West, so when Bonal asks the young man to join him as a tunnel boss, he accepts—even though the old man’s prideful daughter tends to ride his last nerve. But the routine job turns far more dangerous when Feldhake sets out to bury them all. Only Seay and Bonal can keep the crew above ground.<br/>  <br/> Luke Short, along with such legendary authors as Zane Grey and Louis L’Amour, helped transform the stories of the American West from dime-store pulp into popular and respected literature. A winner of the Levi Strauss Golden Saddleman Award, he is a true icon of the genre and a king of western adventure.<br/>  <br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Luke Short
      </h2>
      
      <p class="authorDescription body article">Luke Short is the pen name of Frederick Dilley Glidden (1908&ndash;1975), the bestselling, award-winning author of over fifty classic western novels and hundreds of short stories. Renowned for their action-packed story lines, multidimensional characters, and vibrant dialogue, Glidden&rsquo;s novels sold over thirty million copies. Ten of his novels, including <I>Blood on the Moon</I>,<I> Coroner Creek</I>, and <I>Ramrod</I>, were adapted for the screen. Glidden was the winner of a special Western Heritage Trustees Award and the Levi Strauss Golden Saddleman Award from the Western Writers of America.<BR /> &#160;<BR /> Born in Kewanee, Illinois, Glidden graduated in 1930 from the University of Missouri where he studied journalism.&#160; After working for several newspapers, he became a trapper in Canada and, later, an archaeologist&rsquo;s assistant in New Mexico. His first story, &ldquo;Six-Gun Lawyer,&rdquo; was published in <I>Cowboy Stories</I> magazine in 1935 under the name F. D. Glidden. At the suggestion of his publisher, he used the pseudonym Luke Short, not realizing it was the name of a real gunman and gambler who was a friend of Doc Holliday and Wyatt Earp. In addition to his prolific writing career, Glidden worked for the Office of Strategic Services during World War II. He moved to Aspen, Colorado, in 1946, and became an active member of the Aspen Town Council, where he initiated the zoning laws that helped preserve the town.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?484a2c6b